import type { Routes } from '@angular/router';

import { environment } from '@env/environment';

export const routes: Routes = [
  ...(environment.features.debugWeb ? environment.routes : []),
  { path: 'concursos', loadChildren: () => import('@contest/contest.routes').then((m) => m.CONTEST_ROUTES) },
  { path: 'ingreso', loadChildren: () => import('@session/session.routes').then((m) => m.SESSION_ROUTES) },
  { path: '', loadChildren: () => import('@home/home.routes').then((m) => m.HOME_ROUTES) },
  { path: '**', redirectTo: '' },
];
